import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {handleErrorResponse} from "../utils/util"
import { USER_ROLE } from "../constants/index"
import { TalentViewService, JobService, MasterService } from "../api/services.gen";
import {
    TalentViewJobListData,
    TalentViewJobRetrieveData,
    MasterOptionsMasterListData,
    TalentViewJobOtherListData,
    TalentViewJobUpdateData,
    TalentViewJobCreateData,
    TalentViewJobMobileListData,
    TalentViewBookmarkStatusUpdateData,
    TalentViewJobSuitableFullListData,
    TalentViewJobSuitableListData,
} from "../api/types.gen";
import {INTERNAL_SERVER_ERROR} from "../constants/index";
import i18n from 'i18next';
import { resetAppState } from "../store/common";

export const getTalentJobList = createAsyncThunk(
    "getTalentJobList",
    async (data: TalentViewJobListData, thunkAPI: any) => {
        try {
            const res: any = await TalentViewService.talentViewJobList(data);
            if (res.results.success) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
        }
    },
);

export const getSuitableJob = createAsyncThunk(
    "getSuitableJob",
    async (data: TalentViewJobSuitableListData, thunkAPI: any) => {
        try {
            const res: any = await TalentViewService.talentViewJobSuitableList(data);
            if (res.success) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
        }
    },
);

export const getSuitableJobFull = createAsyncThunk(
    "getSuitableJobFull",
    async (data: TalentViewJobSuitableFullListData, thunkAPI: any) => {
        try {
            const res: any = await TalentViewService.talentViewJobSuitableFullList(data);
            if (res.results.success) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
        }
    },
);

export const getJobDetail = createAsyncThunk(
    "getJobDetail",
    async (data: TalentViewJobRetrieveData, thunkAPI: any) => {
        try {
            const res: any = await TalentViewService.talentViewJobRetrieve(data);
            if (res.success) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
        }
    },
);

export const getOptionsMaster = createAsyncThunk(
    "getOptionsMaster",
    async (data: MasterOptionsMasterListData, thunkAPI: any) => {
        try {
        const res: any = await MasterService.masterOptionsMasterList(data);
        if (res.success) {
            return res.data;
        } else {
            if(res.message) return thunkAPI.rejectWithValue(res.message);
            else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
        }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
        }
    },
);

export const getProfessionList = createAsyncThunk(
    "getProfessionList",
    async (_, thunkAPI: any) => {
        try {
        const res: any = await JobService.jobProfessionListList();
        if (res.success) {
            return res.data;
        } else {
            if(res.message) return thunkAPI.rejectWithValue(res.message);
            else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
        }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
        }
    },
);

export const getOtherJobResults = createAsyncThunk(
    "getOtherJobResults",
    async (data: TalentViewJobOtherListData, thunkAPI: any) => {
        try {
            const res: any = await TalentViewService.talentViewJobOtherList(data);
            if (res.success) {
                return res.data;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
        }
    },
);

export const updateNumberOfViews = createAsyncThunk(
    "updateNumberOfViews",
    async (data: TalentViewJobUpdateData, thunkAPI: any) => {
        try {
            const res: any = await TalentViewService.talentViewJobUpdate(data);
            if (res.success) {
                return;
            } else {
                return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
        }
    },
);

export const sendApplyJob = createAsyncThunk(
    "sendApplyJob",
    async (data: TalentViewJobCreateData, thunkAPI: any) => {
        try {
            const res: any = await TalentViewService.talentViewJobCreate(data);
            if (res.success) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
        }
    },
);

export const getTalentJobListMobile = createAsyncThunk(
    "getTalentJobListMobile",
    async (data: TalentViewJobMobileListData, thunkAPI: any) => {
        try {
            const res: any = await TalentViewService.talentViewJobMobileList(data);
            if (res.results.success) {
                return res;
            } else {
                return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
        }
    },
);

export const setJobBookmark = createAsyncThunk(
    "setJobBookmark",
    async (data: TalentViewBookmarkStatusUpdateData, thunkAPI: any) => {
        try {
            const res: any = await TalentViewService.talentViewBookmarkStatusUpdate(data);
            if (res.success) {
                return res;
            } else {
                return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
        }
    },
);

export const setJobCardBookmark = createAsyncThunk(
    "setJobCardBookmark",
    async (data: TalentViewBookmarkStatusUpdateData, thunkAPI: any) => {
        try {
            const res: any = await TalentViewService.talentViewBookmarkStatusUpdate(data);
            if (res.success) {
                return res;
            } else {
                return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
        }
    },
);

// Initial state of Redux
interface TalentJobState {
    loading: boolean;
    error: string | null;
    success: string | null;
    actionName: string | null;
    actionStatus: string;
    jobList: [];
    countItems: number;
    currentPage: number;
    pageSize: number;
    searchQuery: string | null;
    suitableJob: [];
    suitableJobFull: [];
    suitableJobPC: [];
    totalResults: number;
    pageStatus: string;
    jobDetailData: [];
    optionsMaster: [];
    optionsProfesstion: [];
    otherJobResults: [];
    isApplied: boolean;
    actionType: string;
    jobListMobile: [];
    currentPageLoading: number;
    suitableJobCurrentPage: number;
    isSuitableJobFullHasMore: boolean;
    pageSizeLoading: number;
    totalResultsMobile: number;
    suitableJobTotalResults: number;
    hasMore: boolean;
    chatConversation: null | number;
    isReloadJobList: boolean;
    maxSuitableJobSlide: number;
    minItemsDisplayed: number;
}

const initialState: TalentJobState = {
    loading: false,
    error: null,
    success: null,
    actionName: null,
    actionStatus: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    jobList: [],
    countItems: 0,
    currentPage: 1,
    pageSize: 6,
    searchQuery: "",
    suitableJob: [],
    suitableJobFull: [],
    suitableJobPC: [],
    totalResults: 0,
    pageStatus: "default",
    jobDetailData: [],
    optionsMaster: [],
    optionsProfesstion: [],
    otherJobResults: [],
    isApplied: true,
    actionType: "",
    jobListMobile: [],
    currentPageLoading: 1,
    pageSizeLoading: 6,
    totalResultsMobile: 0,
    suitableJobTotalResults: 0,
    hasMore: true,
    chatConversation: null,
    isReloadJobList: false,
    isMobileScreen: true,
    isSuitableJobFullHasMore: true,
    suitableJobCurrentPage: 0,
    maxSuitableJobSlide: 5,
    minItemsDisplayed: 3,
};

const updateItemsById = (list, updatedItem) =>
    list.map(item => (item.id === updatedItem.id ? updatedItem : item));

export const talentJobSlice = createSlice({
    name: "talentJob",
    initialState,
    reducers: {
        setSuccess: (state, action) => {
            state.success = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setSearchQuery: (state, action) => {
            state.searchQuery = action.payload;
        },
        setPageStatus: (state, action) => {
            state.pageStatus = action.payload;
        },
        setCurrentPageLoading: (state, action) => {
            state.currentPageLoading = action.payload;
        },
        setHasMore: (state, action) => {
            state.hasMore = action.payload;
        },
        setIsReloadJobList: (state) => {
            state.isReloadJobList = !state.isReloadJobList;
        },
        setSuitableJobFull: (state, action) => {
            state.suitableJobFull = action.payload;
        },
        setIsMobileScreen: (state, action) => {
            state.isMobileScreen = action.payload;
        },
        setSuitableJobCurrentPage: (state, action) => {
            state.suitableJobCurrentPage = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
        // reset state
        .addCase(resetAppState, () => initialState)

        // getTalentJobList
        .addCase(getTalentJobList.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(getTalentJobList.fulfilled, (state, action) => {
            state.loading = false;
            state.jobList = action.payload.results?.data;
            state.totalResults = action.payload.results?.total_records;
            state.countItems = action.payload.count;
        })
        .addCase(getTalentJobList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        })

        // getSuitableJob
        .addCase(getSuitableJob.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(getSuitableJob.fulfilled, (state, action) => {
            state.loading = false;
            const suitableJob = action.payload.data;
            if(suitableJob.length > state.maxSuitableJobSlide) {
                state.suitableJob = suitableJob.slice(0, state.maxSuitableJobSlide);
            } else {
                state.suitableJob = suitableJob
            }
        })
        .addCase(getSuitableJob.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        })

        // getSuitableJobFull
        .addCase(getSuitableJobFull.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(getSuitableJobFull.fulfilled, (state, action) => {
            state.loading = false;
            
            state.suitableJobTotalResults = action.payload.count;
            if(state.suitableJobTotalResults == 0) {
                state.suitableJobCurrentPage = 1;
                state.suitableJobFull = [];
            } else {
                const newItems = action.payload.results.data;

                if(state.isMobileScreen) {
                    state.suitableJobFull = [...state.suitableJobFull, ...newItems];
                } else {
                    state.suitableJobPC = newItems
                }
                
                if (state.suitableJobCurrentPage * state.pageSize >= state.suitableJobTotalResults) {
                    state.isSuitableJobFullHasMore = false;
                }
            }
        })
        .addCase(getSuitableJobFull.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        })

        //getJobDetail
        .addCase(getJobDetail.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.actionStatus = "pending";
            state.actionName = "getJobDetail";
        })
        .addCase(getJobDetail.fulfilled, (state, action) => {
            state.loading = false;
            state.jobDetailData = action.payload.data;
            state.isApplied = action.payload.actionType == "apply" || action.payload.actionType == "scout" ? true : false;
            state.actionType = action.payload.actionType;
            state.actionStatus = "fulfilled";
        })
        .addCase(getJobDetail.rejected, (state, action) => {
            state.loading = false;
            // state.error = action.payload as string;
            state.actionStatus = "rejected";
        })

        // getOptionsMaster
        .addCase(getOptionsMaster.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(getOptionsMaster.fulfilled, (state, action) => {
            state.loading = false;
            state.optionsMaster = action.payload;
        })
        .addCase(getOptionsMaster.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        })

        // getProfessionList
        .addCase(getProfessionList.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(getProfessionList.fulfilled, (state, action) => {
            state.loading = false;
            state.optionsProfesstion = action.payload;
        })
        .addCase(getProfessionList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        })

        // getOtherJobResults
        .addCase(getOtherJobResults.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(getOtherJobResults.fulfilled, (state, action) => {
            state.loading = false;
            state.otherJobResults = action.payload;
        })
        .addCase(getOtherJobResults.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        })

        // sendApplyJob
        .addCase(sendApplyJob.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.actionName = "";
        })
        .addCase(sendApplyJob.fulfilled, (state, action) => {
            state.loading = false;
            state.success = action.payload.message;
            state.actionName = "sendApplyJob";
            state.isApplied = true;
            state.chatConversation = action.payload.chat_conversation_id;
        })
        .addCase(sendApplyJob.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
            state.actionName = "";
        })

        // getTalentJobListMobile
        .addCase(getTalentJobListMobile.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.hasMore = false;
        })
        .addCase(getTalentJobListMobile.fulfilled, (state, action) => {
            state.loading = false;
            if(state.currentPageLoading == 1) state.jobListMobile = [];

            let countPageLoading = 0;
            state.totalResultsMobile = action.payload.count;
            if(state.totalResultsMobile == 0) {
                state.currentPageLoading = 1;
                state.jobListMobile = [];
            } else {
                const newItems = action.payload.results.data;
                const merged = [...state.jobListMobile, ...newItems];
                const uniqueMap = new Map();
                merged.forEach(item => {
                    uniqueMap.set(item.id, item);
                });
                state.jobListMobile = Array.from(uniqueMap.values());           
                countPageLoading = Math.ceil(state.totalResultsMobile / state.pageSizeLoading);
            }
            
            if(state.currentPageLoading >= countPageLoading) state.hasMore = false;
            else state.hasMore = true;
        })
        .addCase(getTalentJobListMobile.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        })

        // setJobBookmark
        .addCase(setJobBookmark.pending, (state) => {
            state.error = null;
        })
        .addCase(setJobBookmark.fulfilled, (state, action) => {
            state.actionName = "setJobBookmark";
            state.success = action.payload.message;
            state.jobDetailData.is_bookmarked = action.payload.data.is_bookmarked;
        })
        .addCase(setJobBookmark.rejected, (state, action) => {
            state.error = action.payload as string;
        })

        // setJobCardBookmark
        .addCase(setJobCardBookmark.pending, (state) => {
            state.error = null;
            state.actionName = "setJobCardBookmark";
        })
        .addCase(setJobCardBookmark.fulfilled, (state, action) => {
            state.actionName = "setJobCardBookmark";
            state.success = action.payload.message;
            state.jobList = updateItemsById(state.jobList, action.payload.data);
            state.jobListMobile = updateItemsById(state.jobListMobile, action.payload.data);
            state.suitableJob = updateItemsById(state.suitableJob, action.payload.data);
            state.otherJobResults = updateItemsById(state.otherJobResults, action.payload.data);
            state.suitableJobPC = updateItemsById(state.suitableJobPC, action.payload.data);
            state.suitableJobFull = updateItemsById(state.suitableJobFull, action.payload.data);
        })
        .addCase(setJobCardBookmark.rejected, (state, action) => {
            state.error = action.payload as string;
        })
    }
});
export const {
    setSuccess,
    setError,
    setCurrentPage,
    setSearchQuery,
    setPageStatus,
    setCurrentPageLoading,
    setHasMore,
    setIsReloadJobList,
    setSuitableJobFull,
    setIsMobileScreen, setSuitableJobCurrentPage
} = talentJobSlice.actions;
export default talentJobSlice.reducer;